// extracted by mini-css-extract-plugin
export default {"summary":"NB","separator":"OB","title":"PB","note":"QB","items_wrapper":"RB","member_perk":"SB","info":"TB","extraQuestionsContain":"UB","h1":"VB","p":"WB","btn":"XB","stickyButton":"YB"};
    if(module.hot) {
      // 1738836196763
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  